module.exports = __webpack_public_path__ + "img/变更数据.fcb57fa8.svg";